import { render, staticRenderFns } from "./AwradListDefaultLayout.vue?vue&type=template&id=546a785b&scoped=true"
import script from "./AwradListDefaultLayout.vue?vue&type=script&lang=js"
export * from "./AwradListDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546a785b",
  null
  
)

export default component.exports